var Backbone = require('backbone');

var CocreatorVariableAttribute = Backbone.Model.extend({

	idAttribute: 'id',
  pluralName:  'cocreatorVariableAttributes',

  defaults: {
    'id': -1
  }

});

module.exports = CocreatorVariableAttribute;